/**
 * 股东信息模块
 */

import React, { FC, useMemo, useState } from 'react';
import { ProDetailList } from '@bedrock/eed-react';
import { ChevronDown, ChevronUp } from '@bedrock/icons-react';
import { Button, Tag } from '@bedrock/components';
import {
  FormModule,
  FormItemActualControllerDetailList,
  FormItemShareholderName,
  FormItemShareholdingRatio,
  FormItemSubscribedCapital,
  FormItemDataSource,
} from '@purchase/supplier';

const ShareholderModule: FC<{
  formDetail: any;
  isDiff?: boolean;
}> = ({ formDetail, isDiff = false }) => {
  const [showHistoryShareholders, setShowHistoryShareholders] = useState(false);

  const vendorShareholderCount = useMemo(
    () => formDetail?.vendorShareholderInfos?.length ?? 0,
    [formDetail]
  );
  const hasHistoryShareholders = useMemo(
    () => (formDetail?.vendorQccHistoryShareholderInfos?.length ?? 0) > 0,
    [formDetail]
  );

  const detailListName = useMemo(() => {
    if (isDiff) return 'vendorShareholderInfos';
    return showHistoryShareholders
      ? 'vendorShareholderWithHistoryInfos'
      : 'vendorShareholderInfos';
  }, [isDiff, showHistoryShareholders]);

  return (
    <FormModule
      title="股东信息"
      titleCount={isDiff ? undefined : vendorShareholderCount}
      proCardProps={{
        expandable: true,
        defaultExpanded: vendorShareholderCount > 0,
      }}
    >
      <FormItemActualControllerDetailList
        name={detailListName}
        fieldProps={{ scroll: { x: 1120 } }}
      >
        <ProDetailList.Item
          label="#"
          name="#"
          meta={{ columnProps: { width: 50, fixed: true } }}
        >
          {(value, record, index) => index + 1}
        </ProDetailList.Item>
        <ProDetailList.Item
          label="股东名称"
          name="shareholderName"
          meta={{
            columnProps: { width: 200, className: 'font-bold', fixed: true },
          }}
        >
          {(value, record) =>
            record?.isHistory ? (
              <span className="flex items-center gap-1">
                {value} <Tag color="light-grey" text="历史" size="xSmall" />
              </span>
            ) : (
              value
            )
          }
        </ProDetailList.Item>
        <FormItemShareholdingRatio label="股权比例" name="shareholdingRatio" />
        <FormItemSubscribedCapital
          label="认缴出资额（万）"
          name="subscribedCapital"
        />
        <FormItemDataSource
          label="数据来源"
          name="dataSource"
          meta={{ columnProps: { width: 160 } }}
        />
      </FormItemActualControllerDetailList>

      {/* 展开/收起历史股东 */}
      {hasHistoryShareholders && (
        <div className="mt-2 text-xs text-color-2">
          <Button
            type="link"
            onClick={() => setShowHistoryShareholders((prev) => !prev)}
            suffixIcon={
              showHistoryShareholders ? <ChevronUp /> : <ChevronDown />
            }
          >
            {showHistoryShareholders ? '收起历史' : '展开历史'}
          </Button>
        </div>
      )}
    </FormModule>
  );
};

export default ShareholderModule;
